// Constants
import { SALESFORCE_ORG_ID, SANDBOX_SALESFORCE_ORG_ID } from "./env";

export const SALESFORCE_BASE_FORM_FIELDS = (
  sandbox = false,
  orgIdKey = "oid",
  // timestamp: number,
) => ({
  [orgIdKey]: sandbox ? SANDBOX_SALESFORCE_ORG_ID : SALESFORCE_ORG_ID,
  // TODO: captcha implementation is currently not supported by Salesforce
  // captcha_settings: JSON.stringify({
  //   keyname: "CitizenMSales",
  //   fallback: "true",
  //   orgId: sandbox ? SANDBOX_SALESFORCE_ORG_ID : SALESFORCE_ORG_ID,
  //   ts: timestamp,
  // }),
});

export const SALESFORCE_FORM_TYPE = {
  WebToCase: "WebToCase",
  WebToLead: "WebToLead",
} as const;

export const SALESFORCE_ACTION_URL_BASE = (sandbox = false) =>
  `https://${sandbox ? "test" : "webto"}.salesforce.com`;
